import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


export const constantRoutes = [

    {
        path: '/login',
        component: () => import('@/views/Login.vue'),
        hidden: true
    },


    {
        path: '/',
        name: 'Layout',
        component: () => import('@/layout/Index'),
        redirect: '/home/index',
    },

    {
        path: '/Preview',
        component:resolve => require(['@/views/deviceMgr/Camera/Preview'],resolve),
    },

    {
        path: '/home',
        name: 'Home',
        component: () => import('@/layout/Index'),
        redirect: '/home/index',
        children: [
            {
                path: '/home/index',
                name: 'Index',
                component: () => import('@/views/home/Index1'),
            },
            // {
            //     path: '/home/index',
            //     name: 'Index',
            //     component: () => import('@/views/Visualization/WisdomCloud'),
            // },
        ]
    },



    {
        path: '/User',
        name: 'User',
        component: () => import('@/layout/Index'),
        redirect: '/User/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/User/Page'),
            },
        ]
    },
    {
        path: '/Info',
        name: 'Info',
        component: () => import('@/layout/Index'),
        redirect: '/Info/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Info/Page'),
            },
        ]
    },
    {
        path: '/InfoTitle',
        name: 'InfoTitle',
        component: () => import('@/layout/Index'),
        redirect: '/InfoTitle/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/InfoTitle/Page'),
            },
        ]
    },
    {
        path: '/DeductionItem',
        name: 'DeductionItem',
        component: () => import('@/layout/Index'),
        redirect: '/DeductionItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DeductionItem/Page'),
            },
        ]
    },
    {
        path: '/DeductionHandRecord',
        name: 'DeductionHandRecord',
        component: () => import('@/layout/Index'),
        redirect: '/DeductionHandRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DeductionHandRecord/Page'),
            },
        ]
    },
    {
        path: '/NotCheckinElderly',
        name: 'NotCheckinElderly',
        component: () => import('@/layout/Index'),
        redirect: '/NotCheckinElderly/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/NotCheckinElderly/Page'),
            },
        ]
    },
    {
        path: '/Elderly',
        name: 'Elderly',
        component: () => import('@/layout/Index'),
        redirect: '/Elderly/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Elderly/Page'),
            },
        ]
    },
    {
        path: '/ClockinPlan',
        name: 'ClockinPlan',
        component: () => import('@/layout/Index'),
        redirect: '/ClockinPlan/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Clockin/ClockinPlan/Page'),
            },
        ]
    },
    {
        path: '/ClockinPoint',
        name: 'ClockinPoint',
        component: () => import('@/layout/Index'),
        redirect: '/ClockinPoint/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Clockin/ClockinPoint/Page'),
            },
        ]
    },
    {
        path: '/ClockinRecord',
        name: 'ClockinRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ClockinRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Clockin/ClockinRecord/Page'),
            },
        ]
    },
    {
        path: '/Children',
        name: 'Children',
        component: () => import('@/layout/Index'),
        redirect: '/Children/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Children/Page'),
            },
        ]
    },
    {
        path: '/InstitutionFee',
        name: 'InstitutionFee',
        component: () => import('@/layout/Index'),
        redirect: '/InstitutionFee/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/InstitutionFee/Page'),
            },
        ]
    },
    {
        path: '/PrintClass',
        name: 'PrintClass',
        component: () => import('@/layout/Index'),
        redirect: '/PrintClass/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/PrintClass/Page'),
            },
        ]
    },
    {
        path: '/Nurse',
        name: 'Nurse',
        component: () => import('@/layout/Index'),
        redirect: '/Nurse/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Nurse/Page'),
            },
        ]
    },
    {
        path: '/Report',
        name: 'Report',
        component: () => import('@/layout/Index'),
        redirect: '/Report/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Report/Page'),
            },
            {
                path: 'PageAll',
                component: () => import('@/views/Report/PageAll'),
            },
        ]
    },
    {
        path: '/Mediciner',
        name: 'Mediciner',
        component: () => import('@/layout/Index'),
        redirect: '/Mediciner/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Mediciner/Page'),
            },
        ]
    },


    {
        path: '/Staff',
        name: 'Staff',
        component: () => import('@/layout/Index'),
        redirect: '/Staff/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Staff/ForSuper/Page'),
            },
        ]
    },
    {
        path: '/NursingType',
        name: 'NursingType',
        component: () => import('@/layout/Index'),
        redirect: '/NursingType/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Nursing/NursingType/Page'),
            },
        ]
    },
    {
        path: '/Department',
        name: 'Department',
        component: () => import('@/layout/Index'),
        redirect: '/Department/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Department/Page'),
            },
        ]
    },
    {
        path: '/PrintItem',
        name: 'PrintItem',
        component: () => import('@/layout/Index'),
        redirect: '/PrintItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/PrintItem/Page'),
            },
        ]
    },
    {
        path: '/NursingItem',
        name: 'NursingItem',
        component: () => import('@/layout/Index'),
        redirect: '/NursingItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Nursing/NursingItem/Page'),
            },
        ]
    },
    {
        path: '/NursingLevel',
        name: 'NursingLevel',
        component: () => import('@/layout/Index'),
        redirect: '/NursingLevel/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Nursing/NursingLevel/Page'),
            },
        ]
    },
    {
        path: '/NursingScheduling',
        name: 'NursingScheduling',
        component: () => import('@/layout/Index'),
        redirect: '/NursingScheduling/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Nursing/NursingScheduling/Page'),
            },
        ]
    },
    {
        path: '/NursingChange',
        name: 'NursingChange',
        component: () => import('@/layout/Index'),
        redirect: '/NursingChange/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Nursing/NursingChange/Page'),
            },
        ]
    },
    {
        path: '/NursingRecord',
        name: 'NursingRecord',
        component: () => import('@/layout/Index'),
        redirect: '/NursingRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Nursing/NursingRecord/Page'),
            },
        ]
    },
    {
        path: '/Role',
        name: 'Role',
        component: () => import('@/layout/Index'),
        redirect: '/Role/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Role/Page'),
            },
        ]
    },
    {
        path: '/RoleInstitution',
        name: 'RoleInstitution',
        component: () => import('@/layout/Index'),
        redirect: '/RoleInstitution/PageAdmin',
        children: [
            {
                path: 'PageAdmin',
                component: () => import('@/views/RoleInstitution/ForAdmin/Page'),
            },
            {
                path: 'PageSuper',
                component: () => import('@/views/RoleInstitution/ForSuper/Page'),
            },
        ]
    },
    {
        path: '/Room',
        name: 'Room',
        component: () => import('@/layout/Index'),
        redirect: '/Room/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Room/Page'),
            },
        ]
    },
    {
        path: '/RoomType',
        name: 'RoomType',
        component: () => import('@/layout/Index'),
        redirect: '/RoomType/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RoomType/Page'),
            },
        ]
    },
    {
        path: '/RoomTypePrice',
        name: 'RoomTypePrice',
        component: () => import('@/layout/Index'),
        redirect: '/RoomTypePrice/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RoomTypePrice/Page'),
            },
        ]
    },
    {
        path: '/Berth',
        name: 'Berth',
        component: () => import('@/layout/Index'),
        redirect: '/Berth/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Berth/Page'),
            },
        ]
    },
    {
        path: '/Dishes',
        name: 'Dishes',
        component: () => import('@/layout/Index'),
        redirect: '/Dishes/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Dishes/Page'),
            },
        ]
    },
    {
        path: '/DishesCheckRecord',
        name: 'DishesCheckRecord',
        component: () => import('@/layout/Index'),
        redirect: '/DishesCheckRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DishesCheckRecord/Page'),
            },
        ]
    },
    {
        path: '/DishesPlan',
        name: 'DishesPlan',
        component: () => import('@/layout/Index'),
        redirect: '/DishesPlan/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DishesPlan/Page'),
            },
        ]
    },
    {
        path: '/Building',
        name: 'Building',
        component: () => import('@/layout/Index'),
        redirect: '/Building/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Building/Page'),
            },
        ]
    },
    {
        path: '/WareHouse',
        name: 'WareHouse',
        component: () => import('@/layout/Index'),
        redirect: '/WareHouse/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/WareHouse/Page'),
            },
        ]
    },
    {
        path: '/WaresType',
        name: 'WaresType',
        component: () => import('@/layout/Index'),
        redirect: '/WaresType/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/WaresType/Page'),
            },
        ]
    },
    {
        path: '/Wares',
        name: 'Wares',
        component: () => import('@/layout/Index'),
        redirect: '/Wares/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Wares/Page'),
            },
        ]
    },

    {
        path: '/Menu',
        name: 'Menu',
        component: () => import('@/layout/Index'),
        redirect: '/Menu/List',
        children: [
            {
                path: 'List',
                component: () => import('@/views/Menu/List'),
            },
        ]
    },
    {
        path: '/Zone',
        name: 'Zone',
        component: () => import('@/layout/Index'),
        redirect: '/Zone/List',
        children: [
            {
                path: 'List',
                component: () => import('@/views/Zone/List'),
            },
        ]
    },

    {
        path: '/Institution',
        name: 'Institution',
        component: () => import('@/layout/Index'),
        redirect: '/Institution/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Institution/Page'),
            },
        ]
    },
    {
        path: '/InstitutionDsicount',
        name: 'InstitutionDsicount',
        component: () => import('@/layout/Index'),
        redirect: '/InstitutionDsicount/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/InstitutionDsicount/Page'),
            },
        ]
    },
    {
        path: '/InstitutionArg',
        name: 'InstitutionArg',
        component: () => import('@/layout/Index'),
        redirect: '/InstitutionArg/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/InstitutionArg/Page'),
            },
        ]
    },
    {
        path: '/Arg',
        name: 'Arg',
        component: () => import('@/layout/Index'),
        redirect: '/Arg/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Arg/Page'),
            },
        ]
    },

    {
        path: '/Supplier',
        name: 'Supplier',
        component: () => import('@/layout/Index'),
        redirect: '/Supplier/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Supplier/Page'),
            },
        ]
    },
    {
        path: '/CheckinAssessClass',
        name: 'CheckinAssessClass',
        component: () => import('@/layout/Index'),
        redirect: '/CheckinAssessClass/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CheckinAssessClass/Page'),
            },
        ]
    },
    {
        path: '/ElderlyDrugRecord',
        name: 'ElderlyDrugRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ElderlyDrugRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ElderlyDrugRecord/Page'),
            },
        ]
    },


    {
        path: '/StockOut',
        name: 'StockOut',
        component: () => import('@/layout/Index'),
        redirect: '/StockOut/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/inoutMgr/StockOut/Page'),
            },
        ]
    },
    {
        path: '/StockOut',
        name: 'StockOut',
        component: () => import('@/layout/Index'),
        redirect: '/StockOut/Cart',
        children: [
            {
                path: 'Cart',
                component: () => import('@/views/inoutMgr/StockOut/Cart'),
            },
        ]
    },

    {
        path: '/StockIn',
        name: 'StockIn',
        component: () => import('@/layout/Index'),
        redirect: '/StockIn/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/inoutMgr/StockIn/Page'),
            },
        ]
    },
    {
        path: '/StockIn',
        name: 'StockIn',
        component: () => import('@/layout/Index'),
        redirect: '/StockIn/Cart',
        children: [
            {
                path: 'Cart',
                component: () => import('@/views/inoutMgr/StockIn/Cart'),
            },
        ]
    },
    {
        path: '/Inventory',
        name: 'Inventory',
        component: () => import('@/layout/Index'),
        redirect: '/Inventory/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/inoutMgr/Inventory/Page'),
            },
        ]
    },
    {
        path: '/Inventory',
        name: 'Inventory',
        component: () => import('@/layout/Index'),
        redirect: '/Inventory/Cart',
        children: [
            {
                path: 'Cart',
                component: () => import('@/views/inoutMgr/Inventory/Cart'),
            },
        ]
    },
    {
        path: '/AccidentRecord',
        name: 'AccidentRecord',
        component: () => import('@/layout/Index'),
        redirect: '/AccidentRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RecordManage/AccidentRecord/Page'),
            },
        ]
    },
    {
        path: '/Reception',
        name: 'Reception',
        component: () => import('@/layout/Index'),
        redirect: '/Reception/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/JiedaiMgr/Reception/Page'),
            },
        ]
    },
    {
        path: '/Elderly',
        name: 'Elderly',
        component: () => import('@/layout/Index'),
        redirect: '/Elderly/PageJustView',
        children: [
            {
                path: 'PageJustView',
                component: () => import('@/views/JiedaiMgr/Elderly/PageJustView'),
            },
        ]
    },
    {
        path: '/Berth',
        name: 'Berth',
        component: () => import('@/layout/Index'),
        redirect: '/Berth/PageJustView',
        children: [
            {
                path: 'PageJustView',
                component: () => import('@/views/JiedaiMgr/Berth/PageJustView'),
            },
        ]
    },
    {
        path: '/RetirementSettle',
        name: 'RetirementSettle',
        component: () => import('@/layout/Index'),
        redirect: '/RetirementSettle/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RetirementSettle/Page'),
            },
        ]
    },
    {
        path: '/ConsumptionSettle',
        name: 'ConsumptionSettle',
        component: () => import('@/layout/Index'),
        redirect: '/ConsumptionSettle/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ConsumptionSettle/Page'),
            },
        ]
    },
    {
        path: '/SupplierDrug',
        name: 'SupplierDrug',
        component: () => import('@/layout/Index'),
        redirect: '/SupplierDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ypglMgr/SupplierDrug/Page'),
            },
        ]
    },
    {
        path: '/StockoutDrug',
        name: 'StockoutDrug',
        component: () => import('@/layout/Index'),
        redirect: '/StockoutDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ypglMgr/StockoutDrug/Page'),
            },
        ]
    },
    {
        path: '/WaresTypeDrug',
        name: 'WaresTypeDrug',
        component: () => import('@/layout/Index'),
        redirect: '/WaresTypeDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ypglMgr/WaresTypeDrug/Page'),
            },
        ]
    },
    {
        path: '/WaresDrug',
        name: 'WaresDrug',
        component: () => import('@/layout/Index'),
        redirect: '/WaresDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ypglMgr/WaresDrug/Page'),
            },
        ]
    },
    {
        path: '/WarehouseDrug',
        name: 'WarehouseDrug',
        component: () => import('@/layout/Index'),
        redirect: '/WarehouseDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ypglMgr/WarehouseDrug/Page'),
            },
        ]
    },
    {
        path: '/MedicationGroup',
        name: 'MedicationGroup',
        component: () => import('@/layout/Index'),
        redirect: '/MedicationGroup/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/lryyaoMgr/MedicationGroup/Page'),
            },
        ]
    },
    {
        path: '/MedicationScheduling',
        name: 'MedicationScheduling',
        component: () => import('@/layout/Index'),
        redirect: '/MedicationScheduling/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/lryyaoMgr/MedicationScheduling/Page'),
            },
        ]
    },
    {
        path: '/Patient',
        name: 'Patient',
        component: () => import('@/layout/Index'),
        redirect: '/Patient/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/Patient/Page'),
            },
        ]
    },
    {
        path: '/DepartmentDrug',
        name: 'DepartmentDrug',
        component: () => import('@/layout/Index'),
        redirect: '/DepartmentDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/DepartmentDrug/Page'),
            },
        ]
    },
    {
        path: '/Register',
        name: 'Register',
        component: () => import('@/layout/Index'),
        redirect: '/Register/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/Register/Page'),
            },
        ]
    },
    {
        path: '/InspectionItem',
        name: 'InspectionItem',
        component: () => import('@/layout/Index'),
        redirect: '/InspectionItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/InspectionItem/Page'),
            },
        ]
    },
    {
        path: '/TestItem',
        name: 'TestItem',
        component: () => import('@/layout/Index'),
        redirect: '/TestItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/TestItem/Page'),
            },
        ]
    },
    {
        path: '/TestRecord',
        name: 'TestRecord',
        component: () => import('@/layout/Index'),
        redirect: '/TestRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/TestRecord/Page'),
            },
        ]
    },
    {
        path: '/StockinDrug',
        name: 'StockinDrug',
        component: () => import('@/layout/Index'),
        redirect: '/StockinDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ypglMgr/StockinDrug/Page'),
            },
        ]
    },
    {
        path: '/RechargeRecordDrug',
        name: 'RechargeRecordDrug',
        component: () => import('@/layout/Index'),
        redirect: '/RechargeRecordDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/RechargeRecordDrug/Page'),
            },
        ]
    },
    {
        path: '/PrescriptionDrug',
        name: 'PrescriptionDrug',
        component: () => import('@/layout/Index'),
        redirect: '/PrescriptionDrug/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/PrescriptionDrug/Page'),
            },
        ]
    },
    {
        path: '/PrescriptionTreatment',
        name: 'PrescriptionTreatment',
        component: () => import('@/layout/Index'),
        redirect: '/PrescriptionTreatment/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/PrescriptionTreatment/Page'),
            },
        ]
    },
    {
        path: '/TreatmentItem',
        name: 'TreatmentItem',
        component: () => import('@/layout/Index'),
        redirect: '/TreatmentItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/TreatmentItem/Page'),
            },
        ]
    },
    {
        path: '/FaceDevice',
        name: 'FaceDevice',
        component: () => import('@/layout/Index'),
        redirect: '/FaceDevice/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/deviceMgr/FaceDevice/Page'),
            },
        ]
    },
    {
        path: '/PatrolDevice',
        name: 'PatrolDevice',
        component: () => import('@/layout/Index'),
        redirect: '/PatrolDevice/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/deviceMgr/PatrolDevice/Page'),
            },
        ]
    },
    {
        path: '/PassengerFlow',
        name: 'PassengerFlow',
        component: () => import('@/layout/Index'),
        redirect: '/PassengerFlow/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/PassengerFlow/Page'),
            },
        ]
    },
    {
        path: '/ConsultationRecord',
        name: 'ConsultationRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ConsultationRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/ConsultationRecord/Page'),
            },
        ]
    },
    {
        path: '/PrescriptionCheck',
        name: 'PrescriptionCheck',
        component: () => import('@/layout/Index'),
        redirect: '/PrescriptionCheck/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/kbgliMgr/PrescriptionCheck/Page'),
            },
        ]
    },
    {
        path: '/StockinDrug',
        name: 'StockinDrug',
        component: () => import('@/layout/Index'),
        redirect: '/StockinDrug/Cart',
        children: [
            {
                path: 'Cart',
                component: () => import('@/views/ypglMgr/StockinDrug/Cart'),
            },
        ]
    },
    {
        path: '/ExerciseRecord',
        name: 'ExerciseRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ExerciseRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RecordManage/ActivityRecord/Page'),
            },
        ]
    },
    {
        path: '/CheckinSetmeal',
        name: 'CheckinSetmeal',
        component: () => import('@/layout/Index'),
        redirect: '/CheckinSetmeal/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CheckManger/CheckinSetmeal/Page'),
            },
        ]
    },
    {
        path: '/CareRemind',
        name: 'CareRemind',
        component: () => import('@/layout/Index'),
        redirect: '/CareRemind/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CareRemind/Page'),
            },
        ]
    },
    {
        path: '/NotBalance',
        name: 'NotBalance',
        component: () => import('@/layout/Index'),
        redirect: '/NotBalance/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/NotBalance/Page'),
            },
        ]
    },
    {
        path: '/ElderlyRechargeRecord',
        name: 'ElderlyRechargeRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ElderlyRechargeRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ElderlyRechargeRecord/Page'),
            },
        ]
    },
    {
        path: '/ElderlyDepositRecord',
        name: 'ElderlyDepositRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ElderlyDepositRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ElderlyDepositRecord/Page'),
            },
        ]
    },
    {
        path: '/ElderlyImprestRecord',
        name: 'ElderlyImprestRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ElderlyImprestRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ElderlyImprestRecord/Page'),
            },
        ]
    },
    {
        path: '/RefundRecord',
        name: 'RefundRecord',
        component: () => import('@/layout/Index'),
        redirect: '/RefundRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RefundRecord/Page'),
            },
        ]
    },
    {
        path: '/RoomChange',
        name: 'RoomChange',
        component: () => import('@/layout/Index'),
        redirect: '/RoomChange/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CheckManger/RoomChange/Page'),
            },
        ]
    },
    {
        path: '/FireRecord',
        name: 'FireRecord',
        component: () => import('@/layout/Index'),
        redirect: '/FireRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RecordManage/FireRecord/Page'),
            },
        ]
    },
    {
        path: '/Leave',
        name: 'Leave',
        component: () => import('@/layout/Index'),
        redirect: '/Leave/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RecordManage/LeaveRecord/Page'),
            },
        ]
    },
    {
        path: '/TrainingRecord',
        name: 'TrainingRecord',
        component: () => import('@/layout/Index'),
        redirect: '/TrainingRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RecordManage/TrainRecord/Page'),
            },
        ]
    },
    {
        path: '/VisitRecord',
        name: 'VisitRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ExerciseRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RecordManage/VisitRecord/Page'),
            },
        ]
    },

    {
        path: '/EmergencycallRecord',
        name: 'EmergencycallRecord',
        component: () => import('@/layout/Index'),
        redirect: '/EmergencycallRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/SjMgr/EmergencycallRecord/Page'),
            },
        ]
    },

    {
        path: '/Remind',
        name: 'Remind',
        component: () => import('@/layout/Index'),
        redirect: '/Remind/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/SjMgr/Remind/Page'),
            },
        ]
    },
    {
        path: '/PatrolPoint',
        name: 'PatrolPoint',
        component: () => import('@/layout/Index'),
        redirect: '/PatrolPoint/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/SjMgr/PatrolPoint/Page'),
            },
        ]
    },
    {
        path: '/PatrolPointRecord',
        name: 'PatrolPointRecord',
        component: () => import('@/layout/Index'),
        redirect: '/PatrolPointRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/SjMgr/PatrolPointRecord/Page'),
            },
        ]
    },
    {
        path: '/CheckinAuto',
        name: 'CheckinAuto',
        component: () => import('@/layout/Index'),
        redirect: '/CheckinAuto/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CheckManger/CheckinAuto copy/Page'),
            },
        ]
    },
    {
        path: '/Coupon',
        name: 'Coupon',
        component: () => import('@/layout/Index'),
        redirect: '/Coupon/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Coupon/Page'),
            },
        ]
    },
    {
        path: '/ElBalanceRecord',
        name: 'ElBalanceRecord',
        component: () => import('@/layout/Index'),
        redirect: '/ElBalanceRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ElBalanceRecord/Page'),
            },
            {
                path: 'PageAll',
                component: () => import('@/views/ElBalanceRecord/PageAll'),
            },
        ]
    },
    {
        path: '/CensusAutoRecordMonth',
        name: 'CensusAutoRecordMonth',
        component: () => import('@/layout/Index'),
        redirect: '/CensusAutoRecordMonth/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CensusAutoRecordMonth/Page'),
            },
            {
                path: 'PageAll',
                component: () => import('@/views/CensusAutoRecordMonth/PageAll'),
            },
        ]
    },
    {
        path: '/ChargeItemStatistics',
        name: 'ChargeItemStatistics',
        component: () => import('@/layout/Index'),
        redirect: '/ChargeItemStatistics/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/ChargeItemStatistics/Page'),
            },
            {
                path: 'PageAll',
                component: () => import('@/views/ChargeItemStatistics/PageAll'),
            },
        ]
    },
    {
        path: '/BalanceStatistic',
        name: 'BalanceStatistic',
        component: () => import('@/layout/Index'),
        redirect: '/BalanceStatistic/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/BalanceStatistic/Page'),
            },
            {
                path: 'PageAll',
                component: () => import('@/views/BalanceStatistic/PageAll'),
            },
        ]
    },
    {
        path: '/HeadInsStats',
        name: 'HeadInsStats',
        component: () => import('@/layout/Index'),
        redirect: '/HeadInsStats/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/HeadInsStats/Page'),
            }
        ]
    },
    {
        path: '/NeedVerifyCheck',
        name: 'NeedVerifyCheck',
        component: () => import('@/layout/Index'),
        redirect: '/NeedVerifyCheck/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/NeedVerifyCheck/Page'),
            },
        ]
    },
    {
        path: '/RefundCheck',
        name: 'RefundCheck',
        component: () => import('@/layout/Index'),
        redirect: '/RefundCheck/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RefundCheck/Page'),
            },
        ]
    },
    {
        path: '/RefundAudit',
        name: 'RefundAudit',
        component: () => import('@/layout/Index'),
        redirect: '/RefundAudit/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RefundAudit/PageCheck'),
            },
        ]
    },
    {
        path: '/RefundAuditAdd',
        name: 'RefundAuditAdd',
        component: () => import('@/layout/Index'),
        redirect: '/RefundAuditAdd/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RefundAudit/Page'),
            },
        ]
    },
    {
        path: '/RefundSettle',
        name: 'RefundSettle',
        component: () => import('@/layout/Index'),
        redirect: '/RefundSettle/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RefundSettle/Page'),
            },
        ]
    },
    {
        path: '/DeductionRecord',
        name: 'DeductionRecord',
        component: () => import('@/layout/Index'),
        redirect: '/DeductionRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/DeductionRecord/Page'),
            },
        ]
    },
    {
        path: '/RoomStateDiagram',
        name: 'RoomStateDiagram',
        component: () => import('@/layout/Index'),
        redirect: '/RoomStateDiagram/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/RoomStateDiagram/Page'),
            },
        ]
    },
    {
        path: '/CheckinUnfixedMoney',
        name: 'CheckinUnfixedMoney',
        component: () => import('@/layout/Index'),
        redirect: '/CheckinUnfixedMoney/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CheckinUnfixedMoney/Page'),
            },
        ]
    },
    {
        path: '/Checkin',
        name: 'Checkin',
        component: () => import('@/layout/Index'),
        redirect: '/Checkin/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CheckManger/Checkin/Page'),
            },
        ]
    },
    {
        path: '/WaitRefund',
        name: 'WaitRefund',
        component: () => import('@/layout/Index'),
        redirect: '/WaitRefund/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/WaitRefund/Page'),
            },
        ]
    },
    {
        path: '/WaitRefundRecord',
        name: 'WaitRefundRecord',
        component: () => import('@/layout/Index'),
        redirect: '/WaitRefundRecord/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/WaitRefundRecord/Page'),
            },
        ]
    },
    {
        path: '/HistoricalFiles',
        name: 'HistoricalFiles',
        component: () => import('@/layout/Index'),
        redirect: '/HistoricalFiles/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/HistoricalFiles/Page'),
            },
        ]
    },
    {
        path: '/UploadContractItem',
        name: 'UploadContractItem',
        component: () => import('@/layout/Index'),
        redirect: '/UploadContractItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CheckManger/UploadContractItem/Page'),
            },
        ]
    },
    {
        path: '/UploadContractClass',
        name: 'UploadContractClass',
        component: () => import('@/layout/Index'),
        redirect: '/Contract/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/CheckManger/UploadContractClass/Page'),
            },
        ]
    },
    {
        path: '/CheckinAssessGroup',
        name: 'CheckinAssessGroup',
        component: () => import('@/layout/Index'),
        redirect: '/CheckinAssessGroup/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/EggertManage/CheckinAssessGroup/Page'),
            },
        ]
    },
    {
        path: '/CheckinAssessItem',
        name: 'CheckinAssessItem',
        component: () => import('@/layout/Index'),
        redirect: '/CheckinAssessItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/EggertManage/CheckinAssessItem/Page'),
            },
        ]
    },
    {
        path: '/ElderlyCheckinAssess',
        name: 'ElderlyCheckinAssess',
        component: () => import('@/layout/Index'),
        redirect: '/CheckinAssessItem/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/EggertManage/ElderlyCheckinAssess/Page'),
            },
        ]
    },

    {
        path: '/Error',
        name: 'Error',
        component: () => import('@/layout/Index'),
        redirect: '/Error/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/Error/Page'),
            },
        ]
    },

    {
        path: '/System',
        name: 'System',
        component: () => import('@/layout/Index'),
        redirect: '/System/Info',
        children: [
            {
                path: 'Info',
                component: () => import('@/views/System/Page'),
            },
        ]
    },

    {
        path: '/Staff',
        name: 'Staff',
        component: () => import('@/layout/Index'),
        redirect: '/Staff/PageForAdmin',
        children: [
            {
                path: 'PageForAdmin',
                component: () => import('@/views/Staff/PageForAdmin/Page'),
            },
        ]
    },

    {
        path: '/Staff',
        name: 'Staff',
        component: () => import('@/layout/Index'),
        redirect: '/Staff/PageForInstitution',
        children: [
            {
                path: 'PageForInstitution',
                component: () => import('@/views/Staff/PageForInstitution/Page'),
            },
        ]
    },

    {
        path: '/Staff',
        name: 'Staff',
        component: () => import('@/layout/Index'),
        redirect: '/Staff/PageForSuper',
        children: [
            {
                path: 'PageForSuper',
                component: () => import('@/views/Staff/PageForSuper/Page'),
            },
        ]
    },


    {
        path: '/VideoCamera',
        name: 'VideoCamera',
        component: () => import('@/layout/Index'),
        redirect: '/VideoCamera/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/deviceMgr/VideoCamera/Page'),
            },
        ]
    },

  
    {
        path: '/DHCamera',
        name: 'DHCamera',
        component: () => import('@/layout/Index'),
        redirect: '/DHCamera/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/deviceMgr/DHCamera/Page'),
            },
        ]
    },

    {
        path: '/Camera',
        name: 'Camera',
        component: () => import('@/layout/Index'),
        redirect: '/Camera/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/deviceMgr/Camera/Page'),
            },
        ]
    },
    {
        path: '/PageToGWatch',
        name: 'PageToGWatch',
        component: () => import('@/layout/Index'),
        redirect: '/PageToGWatch/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/deviceMgr/PageToGWatchGov/PageToGWatchGov'),
            },
        ]
    },
    {
        path: '/PageToGWatchAdm',
        name: 'PageToGWatchAdm',
        component: () => import('@/layout/Index'),
        redirect: '/PageToGWatchAdm/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/deviceMgr/PageToGWatch/PageToGWatch'),
            },
        ]
    },
    {
        path: '/YJGateway',
        name: 'YJGateway',
        component: () => import('@/layout/Index'),
        redirect: '/YJGateway/Page',
        children: [
            {
                path: 'Page',
                component: () => import('@/views/deviceMgr/YJGateway/Page'),
            },
        ]
    },





    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/404', hidden: true }

]


const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const createRouter = () => new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // reset router
}


export default router
